// extracted by mini-css-extract-plugin
export default {"container":"cq-z","ratingLayout":"dq-z","ratingLabel":"eq-z","nonInteractiveRatingLabel":"fq-z"};